import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { GET, POST } from '../../../utils/HttpRequests';

export default function OneTimeJobScheduler() {
  const appUrl = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    job_name: '', users_type: '', doosra_inbox_template: '', push_template: '', priorityLevel: '',
  });
  // eslint-disable-next-line no-unused-vars
  const [pageNo, setPageNumber] = useState(1);
  const [inboxTempates, setInboxTemplates] = useState([]);
  const [pushTempates, setPushTemplates] = useState([]);
  const [jobs, setJobs] = useState([]);
  const priorities = ['critical', 'normal'];

  const fetchInboxAndPushTemplates = async () => {
    try {
      const inbxoUrl = `${appUrl}admin/console/doosra-inbox-templates-types`;
      const pushUrl = `${appUrl}admin/console/push-templates-types`;
      const jobsUrl = `${appUrl}admin/console/one-time-jobs`;
      const inboxRes = await GET(inbxoUrl);
      const pushRes = await GET(pushUrl);
      const jobsRes = await GET(jobsUrl);
      setInboxTemplates(inboxRes?.data?.response.templates);
      setPushTemplates(pushRes?.data?.response?.templates);
      setJobs(jobsRes?.data?.response?.jobs);
    } catch (err) {
      console.error(err.message);
    }
  };
  const createJob = async () => {
    const createJobUrl = `${appUrl}admin/console/doosra-inbox-job`;
    const result = await POST(createJobUrl, formData);
    console.log(result);
    await fetchInboxAndPushTemplates();
  };

  useEffect(() => { fetchInboxAndPushTemplates(); }, [pageNo]);

  const onChange = (e) => {
    console.log(e.target.id, e.target.value);
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const displayData = (
    <td colSpan="7"><p style={{ textAlign: 'center' }}> No Records Found </p></td>
  );
  const jobsHTML = jobs && jobs.length > 0 ? jobs.map((job) => (
    <>
      <tr key={Math.random()}>
        <td title={job.job_name}>{job.job_name || '-'}</td>
        <td title={job.users_count}>{job.users_count || '-'}</td>
        <td title={job.doosra_inbox_template}>{job.doosra_inbox_template || '-'}</td>
        <td title={job.push_template}>{job.push_template || '-'}</td>
        <td title={job.status}>{job.status || '-'}</td>
      </tr>
    </>
  ))
    : (
      <tr>
        {displayData}
      </tr>
    );

  return (
    <div style={{
      display: 'flex', padding: '1%', justifyContent: 'space-between', flexWrap: 'wrap', boxShadow: 'none',
    }}
    >
      <div>
        <h4 style={{ paddingRight: '5px' }}>
          Create a new job
        </h4>
      </div>
      <div style={{ flexBasis: '100%' }}>
        <form className="form-horizontal">
          <div style={{ display: 'flex', paddingRight: '10%', margin: '1% 0%' }}>
            <div className="inputs-fl-1">
              <input
                type="text"
                name="job_name"
                className="form-control"
                id="job_name"
                value={formData.job_name}
                placeholder="Enter Job Name"
                onChange={onChange}
              />
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="users_type"
                onChange={onChange}
                value={formData.users_type}
              >
                <option value="" selected="selected">
                  Target Users
                </option>
                <option value="active-users">Active Users</option>
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="doosra_inbox_template"
                onChange={onChange}
                value={formData.doosra_inbox_template}
              >
                <option value="" selected="selected">
                  Select Inbox Tempate
                </option>
                {inboxTempates.map((template) => (
                  <option value={template.type}>
                    {template.type}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="push_template"
                onChange={onChange}
                value={formData.push_template}
              >
                <option value="" selected="selected">
                  Select Push Tempate
                </option>
                {pushTempates.map((template) => (
                  <option value={template.push_type}>
                    {template.push_type}
                  </option>
                ))}
              </select>
            </div>
            <div className="inputs-fl-1">
              <select
                className="form-control"
                id="priorityLevel"
                onChange={onChange}
                value={formData.priorityLevel}
              >
                <option value="" selected="selected">
                  Select Priority
                </option>
                {priorities.map((priority) => (
                  <option value={priority}>
                    {priority}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ display: 'flex' }}>
              <Button
                variant="danger"
                onClick={createJob}
                className="inputs-fl-1"
                style={{ marginRight: '5%' }}
              >
                Create
              </Button>
            </div>
          </div>
        </form>
        <>
          <div>
            <center>
              <h4>
                Total(Showing in table):
                &nbsp;
                {' '}
                {jobs.length}
              </h4>
            </center>
          </div>
          <div className="table-responsive bn">
            <table className="table">
              <thead className="thad-dark">
                <tr style={{ textTransform: 'capitalize' }}>
                  <th>Job Name</th>
                  <th>Users</th>
                  <th>Inbox Template</th>
                  <th>Push Template</th>
                  <th>Job Status</th>
                </tr>
              </thead>
              <tbody>
                {jobsHTML}
              </tbody>
            </table>
          </div>
        </>
      </div>
    </div>
  );
}
